export var slice = Array.prototype.slice;



//////////////////
// WEBPACK FOOTER
// /srv/http/murdocktrust.org/releases/458/web/app/themes/murdock-serenity/node_modules/d3-chord/src/array.js
// module id = 533
// module chunks = 0